import React, { ReactNode, useEffect, useState } from "react";
import { DivPropsWithoutRef } from "react-html-props";
import styled from "styled-components";
import useKeypress from "../../../hooks/useKeypress";
import DrawerContext from "./DrawerContext";

interface DrawerProps extends DivPropsWithoutRef {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
}

const Drawer = (props: DrawerProps) => {
  const { isOpen, onClose, children, ...rest } = props;
  const [open, setOpen] = useState(false);

  useKeypress("Escape", onClose);

  useEffect(() => {
    let timeout;

    if (isOpen) {
      // The timeout allows the content to initially render with open false,
      // the render again with open true. This means we can use CSS animation to
      // make the drawer open.
      timeout = setTimeout(() => setOpen(true), 1);
    } else {
      setOpen(false);
    }

    return () => clearTimeout(timeout);
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const value = {
    isOpen: open,
    onClose,
  };

  return (
    <DrawerContext.Provider value={value}>
      <DrawerWrapper {...rest}>{children}</DrawerWrapper>
    </DrawerContext.Provider>
  );
};

const DrawerWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 30;
`;

export default Drawer;
